<template lang="pug">
  div.c-wrap
    div.c-block
      h1.title-main Опрос для поставщиков услуг
      p.par-reg Для того, чтобы начать заполнение данных по&nbsp;предлагаемым услугам, просим вас ознакомиться с&nbsp;<a href="/uploads/Пользовательское соглашение.pdf" target="_blank">Пользовательским соглашением</a>.

    div.c-block
      div.controls-group.controls-group_v-centered.cont.nav-group
        input-check.nav-group__item(:event="'check-agreement'")
        span.nav-group__item Согласен с&nbsp;Пользовательским соглашением.

    div.c-block
      div.controls-group.btns-group
        btn.btns-group__item(:txt="'Принять'" :isDisabled="!checkAgreement || fetchData" :event="'start'")
        btn.btns-group__item(:baseClass="'btn-sec'" :txt="'Отказаться'" :event="'cancel'")
</template>

<script>
  import { setCookie } from '@/utils';
  import { startSession } from '@/session'
  import { SESSION_COOKIE } from '@/constants'
  // TODO: нужно отметить в стате принято или нет соглашение - не пускать дельше если нет
  import PrimaryButton from '@/components/UI/Button/Button.vue'
  import CheckboxRadio from '@/components/UI/CheckboxRadio/CheckboxRadio.vue'

  export default {
    name: 'start',
    components: {
      'btn': PrimaryButton,
      'input-check': CheckboxRadio
    },
    methods: {
      toStart: function () {
        if (this.checkAgreement) {
          this.fetchData = true;
          this.$store.dispatch('session/getUserId').then((userId) => {
            this.$store.dispatch('polls/getCompanyPolls').then(() => {
                this.$store.dispatch('polls/setCurrentPollById', this.$store.state.polls.polls[0].id)
            })
            startSession(userId)
            this.$router.push('/poll')
          }).catch((e) => {
            this.fetchData = false;
            this.$store.dispatch('session/deleteUser');
            setCookie(SESSION_COOKIE, null, { expires: -1 });
            console.error(e);
          })
        }
      },
      toCancel: function () {
        this.$router.push('/cancel')
      }
    },
    mounted: function () {
      this.$on('check-agreement', () => {
        this.checkAgreement = !this.checkAgreement
      })

      this.$on('start', this.toStart)

      this.$on('cancel', this.toCancel)
    },
    data: function () {
      return {
        checkAgreement: false,
        fetchData: false
      }
    }
  }
</script>
